"use client";
import { jsx as r } from "react/jsx-runtime";
import { createContext as s, useContext as c } from "react";
import { useInkeepSearch as i } from "./use-inkeep-search.js";
import { SearchEventsProviderWithBase as a } from "../../providers/search-events-provider.js";
import { Command as h } from "../../atoms/cmdk/index.js";
import { useInkeepConfig as m } from "../../providers/config-provider.js";
const t = s(void 0), x = (e) => {
  const {
    searchSettings: { defaultQuery: o }
  } = m();
  return /* @__PURE__ */ r(a, { children: /* @__PURE__ */ r(h, { shouldFilter: !1, loop: !1, defaultSearch: o, children: /* @__PURE__ */ r(u, { ...e }) }) });
}, u = ({ children: e, ...o }) => {
  const n = i();
  return /* @__PURE__ */ r(t.Provider, { value: { ...n, ...o }, children: e });
}, C = () => {
  const e = c(t);
  if (!e)
    throw new Error("useSearch must be used within a SearchProvider");
  return e;
};
export {
  x as SearchProvider,
  u as SearchProviderImpl,
  C as useSearch
};
